import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";

import Model from "@tripian/model";
import { api } from "@tripian/core";
import {
  saveNotification,
} from "../redux/action/trip";


const useTimelineTrip = () => {
  const [loadingTimelineTripAdd, setLoadingTimelineTripAdd] = useState<boolean>(false);
  const [loadingTimelineTripUpdate, setLoadingTimelineTripUpdate] = useState<boolean>(false);
  const [loadingTimelineTrips, setLoadingTimelineTrips] = useState<boolean>(false);
  const [timelineTrips, setTimelineTrips] = useState<Model.TimelineTrip[] | undefined>(undefined);

  const dispatch = useDispatch();

    const timelineTripAdd = useCallback(
    (tripProfile: Model.TimelineTripProfile, minDayIndex = 0): Promise<Model.TimelineTrip> => {
      setLoadingTimelineTripAdd(true);

      return api
        .timelineTripAdd(tripProfile, minDayIndex)
        .then(async (trip: Model.TimelineTrip) => {
          return trip;
        })
        .catch(tripAddError => {
          dispatch(
            saveNotification(
              Model.NOTIFICATION_TYPE.ERROR,
              "timelineTripAdd",
              tripAddError
            )
          );
          throw tripAddError;
        })
        .finally(() => {
          setLoadingTimelineTripAdd(false);
        });
    },
    [dispatch]
  );

  /**
   * Fetch all timeline trips (list view - steps are empty)
   */
  const timelineTripsFetch = useCallback(
    (limit = 40): Promise<Model.TimelineTrip[]> => {
      setLoadingTimelineTrips(true);

      return api
        .timelineTrips(limit)
        .then((trips: Model.TimelineTrip[]) => {
          setTimelineTrips(trips);
          return trips;
        })
        .catch(tripsError => {
          dispatch(
            saveNotification(
              Model.NOTIFICATION_TYPE.ERROR,
              "timelineTripsFetch",
              tripsError
            )
          );
          throw tripsError;
        })
        .finally(() => {
          setLoadingTimelineTrips(false);
        });
    },
    [dispatch]
  );

  /**
   * Update a timeline trip segment
   * PUT /timeline/{hash}
   */
  const timelineTripUpdate = useCallback(
    (tripHash: string, segment: Model.TimelineSegmentRequest) => {
      setLoadingTimelineTripUpdate(true);

      return api
        .timelineUpdate(tripHash, segment)
        .then((response) => {
          return response;
        })
        .catch(updateError => {
          dispatch(
            saveNotification(
              Model.NOTIFICATION_TYPE.ERROR,
              "timelineTripUpdate",
              updateError
            )
          );
          throw updateError;
        })
        .finally(() => {
          setLoadingTimelineTripUpdate(false);
        });
    },
    [dispatch]
  );

  /**
   * Optimistically remove a trip from local state by tripHash
   */
  const timelineTripRemoveLocal = useCallback(
    (tripHash: string) => {
      setTimelineTrips(prev => prev?.filter(t => t.tripHash !== tripHash));
    },
    []
  );

  return {
    loadingTimelineTripAdd,
    loadingTimelineTripUpdate,
    loadingTimelineTrips,
    timelineTrips,
    timelineTripAdd,
    timelineTripUpdate,
    timelineTripsFetch,
    timelineTripRemoveLocal,
  };
};

export default useTimelineTrip;
